<template>
  <section>
    <container>
      <h1 class="title">Alle recepten</h1>
      <recipes>
        <recipe-card
          v-for="recipe in RecipesData"
          :key="recipe.id"
          :id="recipe.id"
          :title="recipe.title"
          :persons="recipe.persons"
          :cooking-time="recipe.cookingTime"
          :prep-time="recipe.prepTime"
        />

        <reheat-card
          title=" Tips om KFC leftovers op te warmen"
        />
      </recipes>
    </container>
  </section>
</template>

<script>
import Container from '../components/Container.vue';
import Recipes from '../components/Recipes.vue';
import RecipeCard from '../components/cards/Recipe.vue';
import ReheatCard from '../components/cards/Reheat.vue';
import RecipesData from '../data/recipes.json';

export default {
  name: 'App',
  components: {
    Container,
    Recipes,
    RecipeCard,
    ReheatCard,
  },
  data() {
    return {
      RecipesData,
    };
  },
};
</script>

<style lang="scss" scoped>
h1.title {
  font-family: $national-condensed-bold;
  font-weight: bold;
  font-size: 25px;
  color: #000000;
  text-transform: uppercase;
  margin: 0 0 15px 0;
  @include tablet {
    font-size: 44px;
    text-align: center;
    margin: 0 0 75px 0;
  }
}
</style>
